export const KNOWLEDGE_HUB_URI = 'https://help.mesh.ai/hc/en-us';
